import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import FieldText from '@atlaskit/field-text';
import Form, { Field, FormFooter } from '@atlaskit/form';
import SectionMessage from '@atlaskit/section-message';

// @source
import { Account as API } from '../../../server';
import { fields } from '../../../constants';
import { Messages, Fragment } from '../../components';
import { path } from '../../../utils';
import { User } from '../../../tools';
import { RBSReportLogo } from '../../media';
import * as Styled from './styled';

const initialState = {
  isLoading: false,
  message: false,
};

const initialStatic = {
  password: '',
  username: '',
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.account = User.getUserInfo();
    this.redirect = path.parse('redirect');
    this.state = initialState;
    this.static = initialStatic;
    this.unmount = false;
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillMount() {
    if (this.account) {
      this.setStatic({
        username: this.account.Username,
      });
    }
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(event) {
    event.preventDefault();
    const { history } = this.props;
    const validate = this.form.validate();

    if (!validate.isInvalid) {
      this.setState({
        isLoading: true,
        message: false,
      });

      API.login({
        data: this.static,
        success: () => {
          history.go('/');
        },
        error: (messages) => {
          this.setStateUnmount({
            isLoading: false,
            message: (
              <Messages
                items={messages}
                onClose={() => this.setState({ message: false })}
              />
            ),
          });
        },
      });
    }
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  render() {
    const { isLoading, message } = this.state;
    return (
      <Styled.LoginScope>
        <Styled.Section>
          <Styled.Logo>
            <RBSReportLogo width="200" style={{ fill: '#fff' }} />
          </Styled.Logo>
          <Styled.Title>Log in to continue to RBS Cloud</Styled.Title>
          <Styled.Box>
            <Form
              name="login"
              onSubmit={this.onSubmitHandle}
              ref={(form) => { this.form = form; }}
            >
              <Field {...fields.email.field}>
                <FieldText
                  {...fields.email.fieldText}
                  onChange={event => this.setStatic({ username: event.target.value })}
                  value={this.static.username}
                />
              </Field>
              <Field {...fields.password.field}>
                <FieldText
                  {...fields.password.fieldText}
                  onChange={event => this.setStatic({ password: event.target.value })}
                  value={this.static.password}
                />
              </Field>
              <FormFooter>
                <Button
                  appearance="primary"
                  isLoading={isLoading}
                  onClick={this.onSubmitHandle}
                  shouldFitContainer
                  type="submit"
                >
                  Continue
                </Button>
              </FormFooter>
            </Form>
            {message}
            <Fragment render={this.redirect === 'token'}>
              <Styled.Row>
                <SectionMessage appearance="error">
                  <p>Please login again.</p>
                </SectionMessage>
              </Styled.Row>
            </Fragment>
          </Styled.Box>
        </Styled.Section>
      </Styled.LoginScope>
    );
  }
}

Login.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default Login;
